// import {ROOT_URL} from '../../config';
import {GET_PROFILE, GET_PROFILE_ERR, GET_APPEARANCE, ADD_WISHLIST, DELETE_WISHLIST, GET_WISHLIST_ITEMS, UPDATE_PROFILE, UPDATE_PROFILE_ERR, GET_BLOGGER_APPEARANCE, GET_BLOGGER_PROFILE, GET_BLOGGER_PROFILE_ERR, PROFILE_CHECK} from './type';
// import {axios} from '../common/index';
import { getErrorCode } from '../../assets/util';
// import store from '../../Store';

export function updateProfile(profile, appearance) {
    return function(dispatch, getState, {axios}) {
        // const user_id = profile.user_id;
        if (profile) {
            delete profile.user_id;
        }
        dispatch({
            type: UPDATE_PROFILE,
            payload: null
        });
        axios.post(`/profile`, {
            profile: profile,
            appearance: appearance
        })
        .then((response) => {
            dispatch(getProfile(null));
            dispatch({
                type: UPDATE_PROFILE,
                payload: true,
            });
        })
        .catch((error) => {
            const err_code = getErrorCode(error);
            dispatch({
                type: UPDATE_PROFILE_ERR,
                payload: err_code
            });
            dispatch({
                type: UPDATE_PROFILE,
                payload: false
            })
        })
    }
}

export function updateProfilePicture(image) {
    return (dispatch, getState, {axios}) => {
        dispatch({
            type: UPDATE_PROFILE,
            payload: null
        });
        axios.post(`/profile_img`, {
            image
        })
        .then((response) => {
            dispatch({
                type: UPDATE_PROFILE,
                payload: true
            });
        })
        .catch((error) => {
            const err_code = getErrorCode(error);
            dispatch({
                type: UPDATE_PROFILE_ERR,
                payload: err_code
            });
            dispatch({
                type: UPDATE_PROFILE,
                payload: false
            })
        })
    }
}

export function getProfile(user_id = null) {
    return function(dispatch, getState, {axios}) {
        const params = {};
        if (user_id) {
            params.user_id = user_id
        }
        axios.get(`/profile`, {
            params,
        })
        .then ((response) => {
            dispatch({
                type: GET_PROFILE,
                payload: response.data.profile
            });
            dispatch({
                type: GET_APPEARANCE,
                payload: response.data.appearance
            })
        })
        .catch ((error) => {
            dispatch({
                type: GET_PROFILE_ERR,
                payload: error.response.data? error.response.data.code: 'ERROR.CODE_UNAVAILABLE'
            });
            dispatch({
                type: GET_PROFILE,
                payload: false
            });
        })
    }
}

export function getBloggerProfile(user_id = null) {
    return function(dispatch, getState, {axios}) {
        const params = {};
        if (user_id) {
            params.user_id = user_id
        }
        axios.get(`/profile`, {
            params,
        })
        .then ((response) => {
            dispatch({
                type: GET_BLOGGER_PROFILE,
                payload: response.data.profile
            });
            dispatch({
                type: GET_BLOGGER_APPEARANCE,
                payload: response.data.appearance
            })
        })
        .catch ((error) => {
            dispatch({
                type: GET_BLOGGER_PROFILE_ERR,
                payload: error.response.data? error.response.data.code: 'ERROR.CODE_UNAVAILABLE'
            });
            dispatch({
                type: GET_BLOGGER_PROFILE,
                payload: false
            });
        })
    }
}

export function getWishlistItems() {
    return function(dispatch, getState, {axios}) {
        dispatch({
            type: GET_WISHLIST_ITEMS,
            payload: []
        });
        axios.get(`/wishlist_mat`)
        .then((response) => {
            dispatch({
                type: GET_WISHLIST_ITEMS,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_WISHLIST_ITEMS,
                payload: []
            });
        });
    }
}

export function toggleWishlistItem(mat_var_id, addMode, uid) {
    return function(dispatch, getState, {axios}) {
        if (addMode) {
            dispatch({
                type: ADD_WISHLIST,
                uid: null,
                payload: null
            });
            axios.post(`/wishlist_mat`, {
                mat_var_id: mat_var_id
            })
            .then((response) => {
                // store.dispatch(addNotification(null, 'Added to Wishlist', 'info'));
                dispatch({
                    type: ADD_WISHLIST,
                    uid: uid,
                    payload: true
                });
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    if (error.response.data.code === "ER_DUP_ENTRY") {
                        // store.dispatch(addNotification('Add to Wishlist Failed', 'The product is already in your wishlist', 'error'));
                    } else {
                        // store.dispatch(addNotification(null, 'Add to Wishlist Failed', 'error'));
                    }
                }
                
                dispatch({
                    type: ADD_WISHLIST,
                    uid: uid,
                    payload: false
                });
            })
        } else {
            dispatch({
                type: DELETE_WISHLIST,
                uid: null,
                payload: null
            });
            axios.delete(`/wishlist`, {
                params: {
                    mat_var_id: mat_var_id
                }
            })
            .then((response) => {
                dispatch({
                    type: DELETE_WISHLIST,
                    uid: uid,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_WISHLIST,
                    uid: uid,
                    payload: false
                });
            })
        }
    }
}

export function deleteWishlistItem(mat_var_id, uid) {
    return function(dispatch, getState, {axios}) {
        dispatch({
            type: DELETE_WISHLIST,
            uid: null,
            payload: null
        });
        axios.delete(`/wishlist`, {
            params: {
                mat_var_id
            },
        })
        .then((response) => {
            // store.dispatch(addNotification(null, 'Deleted from Wishlist', 'info'));
            dispatch({
                type: DELETE_WISHLIST,
                uid: uid,
                payload: true
            });
            
            axios.get(`/wishlist_mat`)
            .then((response) => {
                dispatch({
                    type: GET_WISHLIST_ITEMS,
                    payload: response.data
                });
            })
            .catch((error) => {
                // console.log (error.response);
                dispatch({
                    type: GET_WISHLIST_ITEMS,
                    payload: []
                });
            });
            
        })
        .catch((error) => {
            // store.dispatch(addNotification(null, 'Delete from Wishlist Failed', 'error'));
            dispatch({
                type: DELETE_WISHLIST,
                uid: uid,
                payload: false
            });
        })
    }
}

export function setLanguagePreference(lang_code) {
    return (dispatch, getState, {axios}) => {
        axios.post(`/profile/lang`, {lang: lang_code})
    }
}

export function affiliateSignUp(profile, appearance, blogger) {
    return function(dispatch, getState, {axios}) {
        const user_id = profile.user_id;
        delete profile.user_id;
        dispatch({
            type: UPDATE_PROFILE,
            payload: null
        });
        axios.post(`/affiliate_signup`, {
            profile: profile,
            appearance: appearance,
            blogger: blogger,
        })
        .then((response) => {
            dispatch(getProfile(user_id));
            dispatch({
                type: UPDATE_PROFILE,
                payload: true,
            });
        })
        .catch((error) => {
            const err_code = getErrorCode(error);
            dispatch({
                type: UPDATE_PROFILE_ERR,
                payload: err_code
            });
            dispatch({
                type: UPDATE_PROFILE,
                payload: false
            })
        })
    }
}

// export function getUserNotification(user_id = null){
//     console.log("action getUserNotification")
//     return function(dispatch, getState, {axios}){
//         const params = {};
//         if (user_id) {
//             params.user_id = user_id
//         }
//         axios.get(`/user_notification`, {
//             params,
//         })
//         .then((response) => {
//             dispatch({
//                 type: GET_NOTICE,
//                 payload: response.data
//             });
//         })
//         .catch((err) => {
//             dispatch({
//                 type: GET_NOTICE,
//                 payload: {data: [], count: 0}
//             });
//         })
//     }
// }

// export function updateUserNotification(user_id = null){
//     return function(dispatch, getState, {axios}){ 
//         dispatch({
//             type: UPDATE_NOTICE,
//             payload: null
//         });
//         axios.post('/update_notice', {
//             user_id
//         })
//         .then((response) => {
//             dispatch({
//                 type: UPDATE_NOTICE,
//                 payload: true
//             });
//         })
//         .catch((error) => {
//             dispatch({
//                 type: UPDATE_NOTICE,
//                 payload: false
//             })
//         })
//     }
// }
export function updateProfileCheck(user_id, profile) {
    return function(dispatch, getState, {axios}) {
        dispatch({
            type: PROFILE_CHECK,
            payload: null
        });
        axios.post(`/profile_check`, profile)
        .then((response) => {
            dispatch(getProfile(user_id));
            dispatch({
                type: PROFILE_CHECK,
                payload: true,
            });
        })
        .catch((error) => {
            // const err_code = getErrorCode(error);
            dispatch({
                type: PROFILE_CHECK,
                payload: false,
            });
        })
    }
}
